import React, { useEffect, useState } from 'react';
import OrderSummary from './OrderSummary';
import { Col, Row } from 'react-bootstrap';
import { Button, message } from 'antd';
import { UpOutlined } from '@ant-design/icons';
import * as $ from 'jquery';
import 'react-spring-bottom-sheet/dist/style.css';
import { BottomSheet } from 'react-spring-bottom-sheet';
import DeliveryDetails from './DeliveryDetails';
import PaymentInfo from './PaymentInfo';
import PropTypes from 'prop-types';
import { getCustomer, getDeliverWindows, getExtraWork, packageCustomerData } from '../../../../data/API';
import useGetPrice from '../../../../hooks/useGetPrice';

const ReqDeliveryDetails = () => {
  const [orderSummaryOpen, setOrderSummaryOpen] = useState(false);
  const [deliveryWindows, setDeliveryWindows] = useState([]);
  const [extraWork, setExtraWork] = useState([]);
  const [customerInfo, setCustomerInfo] = useState({});
  const { boxPrices } = useGetPrice()

  const [pageType, setPageType] = useState('delivery');

  const [stepRef, setStepRef] = useState(0);

  const getDeliverySlots = async () => {
    try {
      let response = await getDeliverWindows();
      if (response?.data?.results) {
        const formattedSlots = response.data.results.map((slot, index) => ({
          id: slot.id,
          database_id: slot.id,
          start_time: slot.start_time,
          end_time: slot.end_time,
          unique_id: `${slot.id}_${index}`,
          display_value: `${slot.start_time} - ${slot.end_time}`,
          is_anytime: slot.start_time?.toLowerCase().includes('anytime')
        }));
        setDeliveryWindows(formattedSlots);
      }
    } catch (err) {
      return message.error('error fetching delivery windows', err);
    }
  };

  const getExtarworkInfo = async () => {
    try {
      let response = await getExtraWork();
      if (response?.data) {
        setExtraWork(response?.data.results);
      }
    } catch (err) {
      return message.error('error fetching extra work info windows', err);
    }
  };

  const getUserTypeFromToken = () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return 'customer';
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.type;
    } catch (error) {
      console.error('Error decoding token:', error);
      return 'customer';
    }
  };

  const normalizeCustomerData = (data) => {
    if (data.custormerData && !data.data) {
      return data;
    }
    
    if (data.data && data.data.custormerData) {
      return {
        id: data.data.id,
        name: data.data.first_name ? `${data.data.first_name} ${data.data.last_name}` : data.data.name,
        email: data.data.email,
        lastLoggedIn: data.data.lastLoggedIn,
        phone_number: data.data.phone_number,
        secondary_phone_number: data.data.secondary_phone_number,
        company_name: data.data.company_name,
        token: data.data.token,
        refreshToken: data.data.refreshToken,
        custormerData: data.data.custormerData
      };
    }
    
    return data;
  };

  const getCustomerData = async () => {
    try {
      let response;
      const tokenType = getUserTypeFromToken();
      
      if (tokenType === 'customer') {
        response = await getCustomer();
        if (response?.data?.success) {
          setCustomerInfo(response.data.data);
        }
      } 
      else if (tokenType === 'rental_customer') {
        try {
          response = await packageCustomerData();
          if (response?.data) {
            const normalizedData = normalizeCustomerData(response.data);
            setCustomerInfo(normalizedData);
          }
        } catch (apiError) {
          if (apiError.response?.status === 404) {
            console.warn("packageCustomerData endpoint not found for rental user");
            const authData = JSON.parse(localStorage.getItem('authData') || '{}');
            setCustomerInfo({
              id: authData.id,
              name: authData.name,
              email: authData.email
            });
          } else {
            throw apiError; 
          }
        }
      }
      else if (tokenType === 'both_customer') {
        try {
          response = await packageCustomerData();
          if (response?.data) {
            const normalizedData = normalizeCustomerData(response.data);
            setCustomerInfo(normalizedData);
            console.log('Loaded both_customer data via Django API:', normalizedData);
          }
        } catch (apiError) {
          console.error('Error fetching both_customer data, trying storage API:', apiError);
          try {
            response = await getCustomer();
            if (response?.data?.success) {
              setCustomerInfo(response.data.data);
            }
          } catch (storageApiError) {
            console.error('Both APIs failed for both_customer:', storageApiError);
            const authData = JSON.parse(localStorage.getItem('authData') || '{}');
            const token = localStorage.getItem('token');
            setCustomerInfo({
              id: authData.id,
              name: authData.name,
              email: authData.email,
              lastLoggedIn: new Date().toISOString(),
              token: token
            });
          }
        }
      }
    } catch (err) {
      console.error('Error fetching customer data:', err);
      if (err.response?.status !== 404) {
        message.error('Error fetching customer data');
      }
    }
  };

  useEffect(() => {
    getDeliverySlots()
    getExtarworkInfo()
    getCustomerData()
  }, []);

  const showOrderSummary = () => {
    setOrderSummaryOpen(true);
    $('.ant-card-body').trigger('click');
  };

  const hideOrderSummary = () => {
    setOrderSummaryOpen(false);
  };

  const steps = {
    delivery: <DeliveryDetails boxPrices={boxPrices} deliveryWindows={deliveryWindows} extraWork={extraWork} customerInfo={customerInfo} />,
    payment: <PaymentInfo />
  };

  return (
    <div className="m-0">
      <Row className="row d-flex fex-row">
        <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
          <section className="showTabs pb-0 mb-4 pl-3 pr-3 " style={{ backgroundColor: "white" }}>
            <div className="container">
              <div className="row d-flex justify-content-end">
                <div className="col-lg-11 p-0 ">{steps[pageType]}</div>
              </div>
            </div>
          </section>
        </div>
        <div className="col-lg-3 col-md-12 col-sm-12 col-xs-12 p-0 order-summary mb-10">
          <section className="showTabs pb-0 order-summary-section" style={{ backgroundColor: "white" }}>
            <div className="container order-summary-container pr-0">
              <div className="row d-flex mr-0">
                <div className="col-lg-11 p-0 bg-white summary-card order-summary-desktop">
                  <OrderSummary boxPrices={boxPrices} setOrderSummaryOpen={setOrderSummaryOpen} deliveryWindows={deliveryWindows} extraWork={extraWork}/>
                </div>
                <div className="order-summary-mt">
                  <Button
                    icon={<UpOutlined />}
                    onClick={showOrderSummary}
                    className="btn  bg-theme-secondary order-summary-mt-btn "
                    disabled={false}>
                    Order Summary
                  </Button>

                  <BottomSheet
                    open={orderSummaryOpen}
                    blocking={false}
                    data-body-scroll-lock-ignore="true">
                    <div className="order-summary-mt-header" onClick={hideOrderSummary}>
                      <p className="mb-0 ml-4 pt-3 pb-3 title">
                        {' '}
                        <i className="fa fa-chevron-down mr-2"></i> Order Summary
                      </p>
                    </div>
                    <OrderSummary boxPrices={boxPrices} setOrderSummaryOpen={setOrderSummaryOpen} deliveryWindows={deliveryWindows} extraWork={extraWork}/>
                  </BottomSheet>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Row>
    </div>
  );
};

export default ReqDeliveryDetails;

ReqDeliveryDetails.propTypes = {};